/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptionlanguageen3Inputs */

const en_eventdescriptionlanguageen3 = /** @type {(inputs: Eventdescriptionlanguageen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const de_eventdescriptionlanguageen3 = /** @type {(inputs: Eventdescriptionlanguageen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englisch`)
};

/**
* | output |
* | --- |
* | "English" |
*
* @param {Eventdescriptionlanguageen3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptionlanguageen3 = /** @type {((inputs?: Eventdescriptionlanguageen3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptionlanguageen3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptionlanguageen3(inputs)
	return de_eventdescriptionlanguageen3(inputs)
});
export { eventdescriptionlanguageen3 as "eventDescriptionLanguageEn" }